import React from 'react';
import { Menu } from 'lucide-react';
import pepsodentLogo from '../../../assets/unilever-media/Logo.png';
import home from "../../../assets/unilever-media/home.png"

const Header = () => {

  const navigate = () => {
    window.open("https://www.tanyapepsodent.com/ultra-white.html", "_self");
  }

  return (
    <header className="w-full  p-4 md:px-10 flex justify-between items-center">
      <button
      onClick={navigate}
      className=' p-2 mt-2'
      >
        <img src={pepsodentLogo} alt="Pepsodent" className="h-8 md:h-16" />
      </button>
      <div className="flex items-center space-x-4">
        <button onClick={navigate}
        >
          <img src={home} alt="Home" className="h-5 md:h-10 text-white" />
        </button>
      </div>
    </header>
  );
};

export default Header;
